import { AuditEntity } from "@app/common";
import { Api, Column, Display, FormField, prop, required } from "@messaia/cdk";

@Api('tariffstatus')
export class TariffStatus extends AuditEntity {
	@required()
	@FormField({ row: 1, flex: 80 })
	@Column({})
	@Display($localize`:@@name:Name`)
	name: string;

	@required()
	@FormField({ row: 1, flex: 20 })
	@Column({ maxWidth: 80, showGtMd: true })
	@Display('Code')
	code: string;

	@required()
	@FormField({ row: 2 })
	@Display($localize`:@@friendlyName:Friendly name`)
	friendlyName: string;

	@required()
	@FormField({ row: 3 })
	@Display($localize`:@@description:Description`)
	description: string;

	@prop()
	@FormField({ row: 4, rows: 2 })
	@Display($localize`:@@notice:Notice`)
	notice: string;

	@required()
	@FormField({ row: 5 })
	@Column({ event: 'toggle' })
	@Display($localize`:@@enabled:Enabled`)
	enabled: true;
}